import { render } from "./TheRfidCreationForm.vue?vue&type=template&id=0cc47230"
import script from "./TheRfidCreationForm.vue?vue&type=script&lang=js"
export * from "./TheRfidCreationForm.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__